import { render, staticRenderFns } from "./IncomeStatement.vue?vue&type=template&id=6aab8515&scoped=true"
import script from "./IncomeStatement.vue?vue&type=script&lang=js"
export * from "./IncomeStatement.vue?vue&type=script&lang=js"
import style0 from "./IncomeStatement.vue?vue&type=style&index=0&id=6aab8515&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aab8515",
  null
  
)

export default component.exports